module.exports = __webpack_public_path__ + "static/media/portfolio2.13db5e22.jpg";